import { Injectable } from '@angular/core';
import { filterNilValue, Query } from '@datorama/akita';
import { map } from 'rxjs/operators';
import { AuthStore, AuthState } from './auth.store';

@Injectable()
export class AuthQuery extends Query<AuthState> {
  isLoggingIn$ = this.select('isLoggingIn');
  user$ = this.select('user');
  token$ = this.select('token');
  isLoggedIn$ = this.select('isLoggedIn');
  isRegistering$ = this.select('isRegistering');

  constructor(protected store: AuthStore) {
    super(store);
  }

  selectPreference<T>(name: string) {
    return this.select((state) => state.user?.preferences).pipe(
      filterNilValue(),
      map((preferences) =>
        (preferences || []).find((pref) => pref.name === name)
      ),
      map((pref) => pref?.value as any as T),
      filterNilValue()
    );
  }
}
